//importar componete base de modal
import React, { useEffect, useState } from 'react';
import { Card, Container, Form, FormFeedback, Input } from 'reactstrap';
import { mainRequestStatus } from '../../constants/holcim';
import { BaseCustomButton, BaseCustomModal, BaseSelectComponent, GradientDecorationLine } from '../../shared';

// Formik validation
import { useFormik } from "formik";
import * as Yup from "yup";

export const NewServiceModal = ({ props, showModal, setShowModal, modalRespInfo, labType, customers, coordinations, advisers, labSegments, products, labareas, labs, regions, serviceTypes = [] }) => {

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            requestStatus: 'Pendiente de envío',
            laboratoryArea: '',
            laboratory: '',
            laboratorySegment: '',
            coordination: '',
            description: '',
            customer: '',
            product: '',
            technicalAdviser: null,
            phone: '',
            email: '',
            address: '',
            requirements: '',
            region: '', 
            serviceType: '',
        },
        validationSchema: Yup.object({
            region: Yup.string().required("Seleccione una región"),
            customer: Yup.object().required("Seleccione un cliente"),
            technicalAdviser: Yup.string().required("Seleccione un asesor técnico"),
            product: Yup.object().required("Seleccione un producto"),
            laboratory: Yup.object().required("Seleccione un laboratorio"),
            laboratoryArea: Yup.object().required("Seleccione un área de laboratorio"),
            laboratorySegment: Yup.object().required("Seleccione un segmento de laboratorio"),
            coordination: Yup.object().required("Seleccione una coordinación"),
            description: Yup.string().required("Descripción requerida"),
            requirements: Yup.string().required("Requerimientos requeridos"),
            serviceType: Yup.object().required("Seleccione un tipo de servicio"),
        }),
        onSubmit: ({ signature , phone, email, address, ...values }, { resetForm }) => {
            const updToSend = {
                ...values,
                customer: values.customer.value,
                product: values.product.value,
                laboratory: values.laboratory.value,
                laboratoryArea: values.laboratoryArea.value,
                laboratorySegment: values.laboratorySegment.value,
                coordination: values.coordination.value,
                serviceType: values.serviceType.value,
            }
            modalRespInfo(updToSend)
            resetForm()
            setShowModal(false)
        }
    });

    const setValueRegion = (selectObject) => {
        validation.setFieldValue('region', selectObject?.value ?? '')
    }

    const setValueTechnicalAdviser = (selectObject) => {
        const value = selectObject?.value ?? '';
        validation.setFieldValue('technicalAdviser', value);
        const adviser = techAdviserList.find(x => x.id === value);
        validation.setFieldValue('signature', adviser?.signature ?? '');
        validation.setFieldValue('phone', adviser?.phone ?? '');
        validation.setFieldValue('email', adviser?.email ?? '');
        validation.setFieldValue('address', adviser?.address ?? '');
        validation.setFieldTouched('technicalAdviser', true);
    }

    const [techAdviserList, setTechAdviser] = useState([])

    useEffect(() => {
        setTechAdviser(advisers?.filter(x => x.userType === 'Asesor Técnico' && x.recordStatus === true ))
    },[advisers])

    useEffect(() => {
        if (showModal && techAdviserList.length > 0) {
            const authUser = localStorage.getItem("authUser") ? JSON.parse(localStorage.getItem("authUser")) : null;
            if (authUser && authUser.role === 'Asesor Técnico' && !validation.values.technicalAdviser) {
                const currentAdviser = techAdviserList.find(x => x.id === authUser.id);
                if (currentAdviser) {
                    validation.setFieldValue('technicalAdviser', currentAdviser.id);
                    validation.setFieldValue('signature', currentAdviser.signature ?? '');
                    validation.setFieldValue('phone', currentAdviser.phone ?? '');
                    validation.setFieldValue('email', currentAdviser.email ?? '');
                    validation.setFieldValue('address', currentAdviser.address ?? '');
                }
            }
        }
    }, [showModal, techAdviserList])

    const toggle = () => {
        setShowModal(!showModal);
    }

    const onClosed = () => {
        validation.resetForm();
        setShowModal(false);
    }

    //Get current date
    const CurrentDate = new Date();
    const dia = ('0' + CurrentDate.getDate()).slice(-2);
    const mes = ('0' + (CurrentDate.getMonth() + 1)).slice(-2);
    const anio = CurrentDate.getFullYear();

    const buttons = (
        <div className="page-title-box d-flex justify-content-end">
          <BaseCustomButton
            color="success"
            label="Guardar"
            onClick={validation.handleSubmit}
            outline={true}
            className="rounded-3 me-2 p-2"
            icon="mdi mdi-content-save me-1"
          />
          <BaseCustomButton
            color="danger"
            label="Cerrar"
            className="rounded-3 me-3 p-2"
            outline={true}
            onClick={toggle}
            icon="mdi mdi-close-circle me-1"
          />
        </div>
    );

    const childrenBody = (
        <>
        <Form
            className="form-horizontal mt-3 mb-1"
            onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}
        >

            <Container fluid className="" >
                <Card className='' style={{ padding: 10 }}>
                    <div className='m-3'>
                        <GradientDecorationLine />

                        <br />

                        <span className='text-info h6'>Información de Seguimiento</span>

                        <br />
                        <br />

                        <div className="page-title-box d-flex justify-content-center">
                            <div className='w-100 me-3'>
                                <label for="exampleFormControlInput1" className='text-primary'>Tipo de Laboratorio</label>
                                <BaseSelectComponent
                                    options={[{ value: labType, label: labType }] }
                                    value={labType}
                                    placeholder="Seleccione un tipo de laboratorio"
                                    disabled={true}
                                />
                            </div>

                            <div className='w-100'>
                                <label for="exampleFormControlInput1" className='text-primary'>Estatus de Solicitud</label>
                                <BaseSelectComponent
                                    options={mainRequestStatus.map((dir, index) => ({ value: dir.id, label: dir.value })) }
                                    value={validation.values.requestStatus}
                                    onChange={(val) => validation.setFieldValue('requestStatus', val)}
                                    placeholder="Seleccione un estatus"
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <GradientDecorationLine />

                        <span className='text-info h6'>Información General de Servicio</span>

                        <br />
                        <br />

                        <div className="page-title-box d-flex justify-content-center">

                            <div className='w-100 me-3'>
                                <label className='text-primary'>Laboratorio</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={labs.map(lab => ({ value: lab.id, label: lab.name })) }
                                    value={validation.values.laboratory}
                                    onChange={(val) => validation.setFieldValue('laboratory', val)}
                                    placeholder="Seleccione un laboratorio"
                                    error={validation.errors.laboratory}
                                    touched={validation.errors.laboratory}
                                    status={validation.errors.laboratory ? 'error' : ''}
                                />
                            </div>

                            <div className='w-100 me-3'>
                                <label className='text-primary'>Área de Laboratorio</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={labareas.map(area => ({ value: area.id, label: area.name })) }
                                    value={validation.values.laboratoryArea}
                                    onChange={(val) => validation.setFieldValue('laboratoryArea', val)}
                                    placeholder="Seleccione un área de laboratorio"
                                    disabled={false}
                                    error={validation.errors.laboratoryArea}
                                    touched={validation.errors.laboratoryArea}
                                    status={validation.errors.laboratoryArea ? 'error' : ''}
                                />
                            </div>

                            <div className='w-100'>
                                <label className='text-primary'>Tipo de Servicio</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={serviceTypes.map(st => ({ value: st.id, label: st.name })) }
                                    value={validation.values.serviceType}
                                    onChange={(val) => validation.setFieldValue('serviceType', val)}
                                    placeholder="Seleccione un tipo de servicio"
                                    disabled={false}
                                    error={validation.errors.serviceType}
                                    touched={validation.errors.serviceType}
                                    status={validation.errors.serviceType ? 'error' : ''}
                                />
                            </div>
                        </div>

                        <div className="page-title-box d-flex justify-content-center">
                            <div className='w-100 me-3'>
                                <label  className='text-primary'>Segmento</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={labSegments.map(seg => ({ value: seg.id, label: seg.name })) }
                                    value={validation.values.laboratorySegment}
                                    onChange={(val) => validation.setFieldValue('laboratorySegment', val)}
                                    placeholder="Seleccione un segmento de laboratorio"
                                    disabled={false}
                                    error={validation.errors.laboratorySegment}
                                    touched={validation.errors.laboratorySegment}
                                    status={validation.errors.laboratorySegment ? 'error' : ''}
                                />
                            </div>

                            <div className='w-100'>
                                <label  className='text-primary'>Coordinación</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={coordinations.map(coord => ({ value: coord.id, label: coord.name })) }
                                    value={validation.values.coordination}
                                    onChange={(val) => validation.setFieldValue('coordination', val)}
                                    placeholder="Seleccione una coordinación"
                                    disabled={false}
                                    error={validation.errors.coordination}
                                    touched={validation.errors.coordination}
                                    status={validation.errors.coordination ? 'error' : ''}
                                />
                            </div>

                        </div>

                        <div className="page-title-box d-flex justify-content-center">
                            <div className='w-100'>
                                <label className='text-primary'>Localidad</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={regions.map(region => ({ value: region.id, label: `${region.state}-${region.municipality}` }))}
                                    value={validation.values.region}
                                    onChange={setValueRegion}
                                    placeholder="Seleccione una localidad"
                                    status={validation.touched.region || validation.errors.region ? 'error' : ''}
                                    disabled={false}
                                    error={validation.errors.region}
                                    touched={validation.touched.region}
                                />
                            </div>
                        </div>

                        <label className='text-primary'>Descripción</label>
                        <Input
                            name="description"
                            required
                            className="form-control text-primary rounded-3"
                            rows="3"
                            placeholder="Descripción"
                            type="textarea"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.description || ""}
                        />
                        {validation.touched.description && validation.errors.description ? (
                            <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                        ) : null}

                        <GradientDecorationLine />

                        <span className='text-info h6'>Información Control Interno</span>

                        <br />
                        <br />

                        <div className="page-title-box d-flex justify-content-center">

                            <div className='w-100 me-3'>
                                <label  className='text-primary'>Nombre del Cliente</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={customers.map(cust => ({ value: cust.id, label: cust.name })) }
                                    value={validation.values.customer}
                                    onChange={(val) => validation.setFieldValue('customer', val)}
                                    placeholder="Seleccione un cliente"
                                    disabled={false}
                                    error={validation.errors.customer}
                                    touched={validation.errors.customer}
                                    status={validation.errors.customer ? 'error' : ''}
                                />
                                
                            </div>

                            <div className='w-100'>
                                <label  className='text-primary'>Producto</label>
                                <BaseSelectComponent
                                    onChangeAsObject={true}
                                    options={products.map(prod => ({ value: prod.id, label: prod.name })) }
                                    value={validation.values.product}
                                    onChange={(val) => validation.setFieldValue('product', val)}
                                    placeholder="Seleccione un producto"
                                    disabled={false}
                                    error={validation.errors.product}
                                    touched={validation.errors.product}
                                    status={validation.errors.product ? 'error' : ''}
                                />
                            </div>

                        </div>

                        <GradientDecorationLine />

                        <span className='text-info h6'>Información Particular de Servicio</span>

                        <br />
                        <br />

                        <div className="page-title-box d-flex justify-content-center">

                            <div className='w-100 me-3'>
                                <label  className='text-primary'>Asesor Técnico</label>
                                <BaseSelectComponent   
                                    onChangeAsObject={true}
                                    options={techAdviserList.map(tech => ({ 
                                        value: tech.id, 
                                        label: `${tech.name} ${tech.surname}` 
                                    }))}
                                    value={validation.values.technicalAdviser}
                                    onChange={(val) => setValueTechnicalAdviser(val)}
                                    placeholder="Seleccione un asesor técnico"
                                    disabled={false}
                                    error='Seleccione un asesor técnico'
                                    touched={validation.errors.technicalAdviser && validation.touched.technicalAdviser}
                                    status={validation.errors.technicalAdviser && validation.touched.technicalAdviser ? 'error' : ''}
                                />
                            </div>

                            <div className='w-100 me-3'>
                                <label  className='text-primary'>Firma</label>
                                <Input
                                    type="text"
                                    className="form-control text-primary rounded-3"
                                    id="signature"
                                    placeholder='Firma del Asesor Técnico'
                                    disabled
                                    value={validation.values.signature ?? '-'}
                                />
                            </div>

                            <div className='w-100 me-3'>
                                <label className='text-primary'>Teléfono</label>
                                <Input
                                    disabled
                                    name="phone"
                                    className="form-control text-primary rounded-3"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.phone ?? '-'}
                                />
                            </div>

                            <div className='w-100'>
                                <label  className='text-primary'>Fecha de Solicitud</label>
                                <input type="text" className="form-control text-primary rounded-3" placeholder={`${dia}-${mes}-${anio}`} disabled />
                            </div>
                        </div>

                        <div className="page-title-box d-flex justify-content-center">
                            <div className='w-50 me-3'>
                                <label for="exampleFormControlInput1" className='text-primary'>E-Mail</label>
                                <Input
                                    disabled
                                    name="email"
                                    className="form-control text-primary rounded-3"
                                    placeholder="name@example.com"
                                    type="email"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.email ?? '-'}
                                />
                            </div>

                            <div className='w-100'>
                                <label for="exampleFormControlInput1" className='text-primary'>Domicilio</label>
                                <Input
                                    disabled
                                    name="address"
                                    className="form-control text-primary rounded-3"
                                    placeholder="Domicilio"
                                    type="text"
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.address ?? '-'}
                                />
                            </div>

                        </div>

                        <label for="exampleFormControlTextarea1" className='text-primary'>Requerimientos especiales u observaciones</label>
                        <textarea
                            name="requirements"
                            required
                            className="form-control text-primary rounded-3"
                            rows="3"
                            placeholder="Requerimientos"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.requirements || ""}
                        />
                    </div>
                </Card>
            </Container>

            {buttons}
        </Form>
        </>
    );

    const title = (
        <div className="d-flex ms-3 p-0">
            <label className="m-0 p-0">
            <h4 className="text-primary m-0 ps-4">Solicitud de Servicio</h4>
            </label>
        </div>
    )

    return (
        <BaseCustomModal
            title={title}
            onClosed={onClosed}
            isModalOpen={showModal}
            handleOk={validation.handleSubmit}
            handleCancel={toggle}
            children={childrenBody}
            width={{
                xs: '90%',
                sm: '80%',
                md: '80%',
                lg: '80%',
                xl: '80%',
                xxl: '80%',
            }}
            centered
            style={{ top: '5%' }}
            footer={null}
        />
    );
};
